"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _FiatSidePaneComponent = _interopRequireDefault(require("./FiatSidePaneComponent"));
var _withdrawActions = require("../../../redux/actions/withdrawActions");
var _positionSelectors = require("../../../redux/selectors/positionSelectors");
var _config = _interopRequireDefault(require("../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var productSymbol = (0, _lodash.get)(ownProps, 'product.ProductSymbol', null);
  var productConfig = _config["default"].Deposit[productSymbol] || {};
  var productId = (0, _lodash.get)(ownProps, 'product.ProductId', null);
  var position = (0, _positionSelectors.positionByProductIdSelector)(productId)(state);
  var _state$withdraw = state.withdraw,
    fee = _state$withdraw.withdrawFee,
    AccountProviderId = _state$withdraw.AccountProviderId,
    TemplateType = _state$withdraw.template.TemplateType;
  var TicketAmount = (0, _lodash.get)(state, ['withdraw', 'TicketAmount'], null);
  var withdrawDetailsInfo = _config["default"].Withdraw.WithdrawDetails;
  var isDepositDisabled = ownProps.isDepositDisabled,
    isWithdrawDisabled = ownProps.isWithdrawDisabled;
  return {
    TicketAmount: TicketAmount,
    position: position,
    fee: fee,
    AccountProviderId: AccountProviderId,
    TemplateType: TemplateType,
    productConfig: productConfig,
    withdrawDetailsInfo: withdrawDetailsInfo,
    isDepositDisabled: isDepositDisabled,
    isWithdrawDisabled: isWithdrawDisabled
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendToAddress: function sendToAddress(payload) {
      return dispatch((0, _withdrawActions.createWithdrawTicket)(payload));
    },
    getWithdrawFee: function getWithdrawFee(productId, amount, AccountProviderId) {
      return dispatch((0, _withdrawActions.getWithdrawFee)(productId, amount, AccountProviderId));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FiatSidePaneComponent["default"]);